import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import LanguageSync from './components/LanguageSync';

import './css/layout.css';
import './css/common.css';
import './css/main.css';
import './css/member.css';
import './css/table.css';
import './css/modal.css';

import Router from './common/router';
// 공지 관문 — 라우트 전체를 한 번에 감싼다(면제 경로는 관문 내부 isExemptPath 가 거른다).
import RequiredNoticeGuard from './components/common/RequiredNoticeGuard';
import useStoreNo from './hooks/useStoreNo';
import Footer from './components/footer';
import Header from './components/header';
import MobileFooter from './pages/admin/Footer';
import MobileHeader from './pages/admin/Header';

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const storeNo = useStoreNo();

  // (Removed dynamic import to avoid FOUC; CSS is now statically imported above)

  useEffect(() => {
    const path = location.pathname;
    const isPublicPath = p =>
      p === '/' ||
      p === '/login' ||
      p === '/store-guide' ||
      p.startsWith('/mobile') ||
      p.startsWith('/app/qr') || // 앱 QR 진입(공개 역매핑) — 전역 로그인가드 스킵
      p.startsWith('/app/link') || // 앱 미설치 폴백 랜딩 — 전역 로그인가드 스킵
      p.startsWith('/admin/login') ||
      p.startsWith('/popup/');

    let userInfoStored = null;
    try {
      const persisted = localStorage.getItem('persist:root');
      if (persisted) {
        const root = JSON.parse(persisted);
        userInfoStored =
          root && root.userInfo ? JSON.parse(root.userInfo) : null;
      }
    } catch (e) {}

    // 이미 로그인한 사용자가 로그인 페이지로 접근하면 첫 페이지로 이동
    if (path === '/login' || path === '/') {
      if (userInfoStored && userInfoStored.id && storeNo) {
        navigate(`/${storeNo}/gift-list`, { replace: true });
      }
      return;
    }

    // 보호 경로 접근 시 로그인 상태 필수 (모바일 경로는 공개)
    if (!isPublicPath(path)) {
      if (!userInfoStored || !userInfoStored.id) {
        Swal.fire({
          icon: 'warning',
          title: '로그인 필요',
          text: '로그인이 필요합니다. 로그인 페이지로 이동합니다.',
          confirmButtonText: '확인',
        }).then(() => {
          navigate('/login', { replace: true });
        });
      }
    }
  }, [location.pathname, navigate, storeNo]);

  const isPopupPath = location.pathname.startsWith('/popup/');
  const isGuidePath = location.pathname === '/store-guide';

  return (
    <>
      <LanguageSync />
      {!isPopupPath && !isGuidePath &&
        (location.pathname.startsWith('/mobile') ? (
          <MobileHeader />
        ) : (
          <Header />
        ))}
      <RequiredNoticeGuard>
        <Router />
      </RequiredNoticeGuard>
      {!isPopupPath && !isGuidePath &&
        (location.pathname.startsWith('/mobile') ? (
          <MobileFooter />
        ) : (
          <Footer />
        ))}
    </>
  );
}

export default App;
